var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入【角色名、标识】查询" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "keywords", $$v)
                      },
                      expression: "listQuery.keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "sysOrg:combobox",
                          expression: "'sysOrg:combobox'",
                        },
                      ],
                      staticClass: "filter-item",
                      attrs: { placeholder: "组织", clearable: "" },
                      model: {
                        value: _vm.listQuery.orgId,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "orgId", $$v)
                        },
                        expression: "listQuery.orgId",
                      },
                    },
                    _vm._l(_vm.orgList, function (item) {
                      return _c("el-option", {
                        key: item.orgCode,
                        attrs: { label: item.orgName, value: item.orgId },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-circle-plus" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("新建")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "角色唯一标识", align: "center", prop: "roleKey" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "名称", align: "center", prop: "roleName" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "是否默认角色",
              align: "center",
              prop: "defaultRule",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type == 2
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v("否")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "组织名称", align: "center", prop: "orgName" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "备注", align: "center", prop: "remark" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            scope.row.createTime,
                            "{y}-{m}-{d} {h}:{i}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "260" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-edit",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleUpdate(scope.row)
                        },
                      },
                    }),
                    _vm._v(" "),
                    scope.row.type !== -1 && scope.row.type !== 0
                      ? _c("el-button", {
                          attrs: {
                            size: "mini",
                            type: "danger",
                            icon: "el-icon-delete",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(scope.row)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: {
                        type: "warning",
                        size: "mini",
                        icon: "el-icon-s-data",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleRoleRes(scope.row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            key: "2",
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            "destroy-on-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.midData,
                "label-position": "right",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isUpdate,
                      expression: "isUpdate",
                    },
                  ],
                  attrs: { label: "ID" },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.midData.roleId,
                      callback: function ($$v) {
                        _vm.$set(_vm.midData, "roleId", $$v)
                      },
                      expression: "midData.roleId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "roleName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.midData.roleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.midData, "roleName", $$v)
                      },
                      expression: "midData.roleName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.midData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.midData, "remark", $$v)
                      },
                      expression: "midData.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否默认角色", prop: "defaultRule" } },
                [
                  _c("el-switch", {
                    attrs: { "active-text": "是", "inactive-text": "否" },
                    model: {
                      value: _vm.midData.defaultRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.midData, "defaultRule", $$v)
                      },
                      expression: "midData.defaultRule",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#999",
                        "font-size": "12px",
                      },
                    },
                    [
                      _vm._v(
                        "(扫描登录用户赋予的角色，此角色一般拥有最小的权限)" +
                          _vm._s(_vm.midData.defaultRule)
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sw-drawer__footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus === "create"
                        ? _vm.createData()
                        : _vm.updateData()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogResVisible,
            title: "角色授权",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogResVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "contactForm" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "资源" } },
                [
                  _c("el-tree", {
                    ref: "resTree",
                    staticStyle: { "background-color": "#ecf5ff" },
                    attrs: {
                      data: _vm.resTree,
                      props: _vm.defaultProps,
                      "show-checkbox": _vm.sureFlag,
                      "node-key": "resId",
                      "default-expand-all": "",
                      "highlight-current": "",
                    },
                    on: { "check-change": _vm.handleCheckBoxClick },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _vm.sureFlag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleUpdateRoleRes()
                            },
                          },
                        },
                        [_vm._v("确定")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }